import { Helmet } from 'react-helmet-async';

// Shared web-font loader for every PUBLIC page (landing, pricing, auth).
// One place to change the typography stack. Loaded via Helmet so the fonts are
// only fetched on public surfaces, not inside the logged-in app.
// Stack: Barlow Condensed (display) / Barlow (body) / IBM Plex Mono (log voice).

export default function PublicFonts() {
  return (
    <Helmet>
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
      <link
        href="https://fonts.googleapis.com/css2?family=Barlow+Condensed:wght@600;700&family=Barlow:wght@400;500;600&family=IBM+Plex+Mono:wght@400;500&display=swap"
        rel="stylesheet"
      />
    </Helmet>
  );
}
